import { render, staticRenderFns } from "./panel_jifen.vue?vue&type=template&id=1fa91148&scoped=true&"
import script from "./panel_jifen.vue?vue&type=script&lang=js&"
export * from "./panel_jifen.vue?vue&type=script&lang=js&"
import style0 from "./panel_jifen.vue?vue&type=style&index=0&id=1fa91148&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa91148",
  null
  
)

export default component.exports